---
title: E-Mail & Postfach einrichten
parent: Dokumentation
parentHref: /docs
---

# E-Mail-Postfach einrichten

Ihr TOBY-Tarif enthält eine professionelle E-Mail-Adresse passend zu Ihrer Domain (zum Beispiel info@ihre-domain.de) mit einem **15 GB Postfach (Maxi-Postfach)** sowie unbegrenzt vielen E-Mail-Weiterleitungsadressen. Sie benötigen weitere Postfächer oder zusätzlichen Speicher? Sie können jederzeit ein weiteres 15 GB Postfach hinzufügen — siehe [Preisliste](/de/pricing).

## 1. Postfach in TOBY erstellen

1. Öffnen Sie **Einstellungen → E-Mail** in TOBY.
2. Wählen Sie die gewünschte Adresse (z. B. info@, hallo@ oder kontakt@) und erstellen Sie das Postfach.
3. **Passwort kopieren:** TOBY zeigt Ihr generiertes Postfach-Passwort direkt nach der Erstellung einmalig an. Kopieren oder speichern Sie es, bevor Sie das Fenster schließen. (Falls Sie es einmal verlieren, können Sie unter **Einstellungen → E-Mail** mit einem Klick ein neues Passwort generieren – Ihre vorhandenen E-Mails bleiben sicher.)

## 2. E-Mails im Browser lesen und versenden (Webmail)

Sie können Ihr Postfach von jedem Computer- oder Handy-Browser aus öffnen, ohne eine App zu installieren:

- **Webmail-Adresse:** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **Benutzername:** Ihre vollständige E-Mail-Adresse (z. B. info@ihre-domain.de)
- **Passwort:** das Postfach-Passwort aus **Einstellungen → E-Mail**

## 3. Handy oder Computer verbinden (IMAP & SMTP)

Um E-Mails in **Apple Mail (iPhone, iPad, Mac)**, **Gmail / Android Mail**, **Outlook** oder **Thunderbird** zu lesen und zu versenden, fügen Sie in Ihrer Mail-App ein neues **IMAP**-Konto hinzu und geben Sie diese Server-Einstellungen ein:

| Einstellung | Wert |
| --- | --- |
| **Konto-Typ** | IMAP |
| **E-Mail-Adresse / Benutzername** | Ihre vollständige E-Mail-Adresse (z. B. info@ihre-domain.de) |
| **Passwort** | Ihr Postfach-Passwort aus Einstellungen → E-Mail |
| **Posteingangsserver (IMAP)** | mail.tobysite.com |
| **Eingangs-Port** | 993 (SSL/TLS) |
| **Postausgangsserver (SMTP)** | mail.tobysite.com |
| **Ausgangs-Port** | 465 (SSL/TLS) oder 587 (STARTTLS) |

> **Wichtig:** Stellen Sie sicher, dass Sie Ihre **vollständige E-Mail-Adresse** (inklusive @ihre-domain.de) als Benutzername für **sowohl** den Posteingangsserver (IMAP) **als auch** den Postausgangsserver (SMTP) eingeben.

### Schritt für Schritt auf iPhone & iPad (iOS Mail)

1. Öffnen Sie die iPhone-**Einstellungen**-App → **Apps** → **Mail** → **Mail-Accounts** → **Account hinzufügen** → **Andere** → **Mail-Account hinzufügen**.
2. Geben Sie Ihren Namen, Ihre vollständige E-Mail-Adresse, Ihr Postfach-Passwort und eine kurze Beschreibung ein. Tippen Sie auf **Weiter**.
3. Lassen Sie oben **IMAP** ausgewählt.
4. Geben Sie unter **Posteingangsserver** und **Postausgangsserver** als Hostname mail.tobysite.com, als Benutzername Ihre vollständige E-Mail-Adresse und Ihr Postfach-Passwort ein.
5. Tippen Sie auf **Weiter** und dann auf **Sichern**.

### Schritt für Schritt auf Android (Gmail-App)

1. Öffnen Sie die **Gmail**-App, tippen Sie oben rechts auf Ihr Profilbild → **Weiteres Konto hinzufügen** → **Sonstige**.
2. Geben Sie Ihre vollständige E-Mail-Adresse ein und tippen Sie auf **Manuelle Einrichtung** → **Persönlich (IMAP)**, dann geben Sie Ihr Passwort ein.
3. Geben Sie für den **Posteingangsserver** als Server mail.tobysite.com, Port 993 und Sicherheitstyp SSL/TLS ein.
4. Geben Sie für den **Postausgangsserver (SMTP)** als Server mail.tobysite.com, Port 465 (SSL/TLS) ein und stellen Sie sicher, dass **Anmeldung erforderlich** mit Ihrer vollständigen E-Mail-Adresse aktiviert ist.
5. Tippen Sie auf **Weiter**, um den Vorgang abzuschließen.

Weiter: [Newsletter & Ankündigungen](/de/docs/newsletter).
